// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","869":"styles"}[chunkId] + "-" + {"245":"27b74c24255231dde102","453":"c9a86c117ed285a46a6a","869":"98c8ecb5b9e792326f6f"}[chunkId] + ".js";
};